/**
 * Activity lines are mostly plain text from server i18n; normalize for detection.
 * @param {string} [html]
 * @returns {string}
 */
export function stripHtmlForActivity(html) {
  return String(html ?? '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Snooze-related activity (locale-agnostic heuristic on common English + sample Arabic tokens).
 * @param {string} [content]
 */
export function isSnoozeRelatedActivityContent(content) {
  const t = stripHtmlForActivity(content).toLowerCase();
  if (!t) return false;
  if (/(^|\s)(snooz|unsnooz)/i.test(t)) return true;
  // Arabic: snooze / postpone (common phrasing varies by locale)
  if (/تأجيل|غفوة|إيقاف مؤقت|إلغاء التأجيل|مؤجل/i.test(t)) return true;
  return false;
}

function escapeHtml(text) {
  return String(text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/**
 * Wrap actor names and the English word "You" in <strong> for activity lines.
 * Expects plain text / safe HTML from the server; escapes first then injects <strong>.
 * @param {string} raw
 * @param {string[]} actorNames
 */
export function formatActivityActorBoldHtml(raw, actorNames = []) {
  let s = escapeHtml(raw ?? '');

  s = s.replace(/\b(You)\b/g, '<strong>$1</strong>');

  const names = [
    ...new Set(
      (actorNames || []).map(n => String(n).trim()).filter(n => n.length >= 2)
    ),
  ].sort((a, b) => b.length - a.length);

  names.forEach(name => {
    const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const re = new RegExp(`(${escaped})`, 'gi');
    s = s.replace(re, '<strong>$1</strong>');
  });

  return s;
}
